module.exports = __webpack_public_path__ + "img/star-icon.82f8e364.svg";